import Swiper, { Navigation, Pagination, EffectFade } from 'swiper';
import $ from 'jquery';

$(function() {

  Swiper.use([Navigation, Pagination, EffectFade]);

  // Card Carousels
  const cardContainers = document.querySelectorAll('.js-cc-swiper');

  cardContainers.forEach((element) => {

    // Setup main swiper options
    let options = {
      slidesPerView: 1,
      centeredSlides: true,
      speed: 500,
      spaceBetween: 50,
      // effect: 'fade',
      navigation: {
        nextEl: '.js-cc-right',
        prevEl: '.js-cc-left',
      },
    };

    // Add options specific to small polaroid carousel
    if (!element.parentElement.classList.contains('card-carousel--lg')) {
      options.initialSlide = 1;
      options.spaceBetween = 0;
      options.effect = 'slide';
      options.on = {
        beforeTransitionStart: (swiper) => {
          const index = swiper.activeIndex;
          const prevIndex = swiper.previousIndex;
          if (index !== prevIndex) {
            const $parent = $(swiper.$wrapperEl).parents('.card-carousel');
            $parent.removeClass(`card-carousel--bg-${prevIndex}`);
            $parent.addClass(`card-carousel--bg-${index}`);
          }
        },
      };
    }

    // Init swiper
    new Swiper('.js-cc-swiper', options);

  });

  // Testimonial Carousels
  const testimonialCarousel = new Swiper('.js-test-swiper', {
    slidesPerView: 1,
    speed: 500,
    spaceBetween: 120,
    loop: true,
    navigation: {
      nextEl: '.js-test-next',
    }
  });

  // Centered Testimonial Carousel
  const centeredTestimonials = new Swiper('.js-test-centered-swiper', {
    slidesPerView: 1,
    speed: 500,
    spaceBetween: 120,
    loop: true,
    navigation: {
      nextEl: '.js-test-next',
      prevEl: '.js-test-prev',
    }
  });

  // Product Gallery
  const productGallery = new Swiper('.js-product-swiper', {
    slidesPerView: 1,
    speed: 500,
    spaceBetween: 50,
    loop: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    }
  })

});
